'use client';

import React, { useRef, useEffect } from 'react';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import '../styles/top-bookmakers.css';

interface Bookmaker {
  id: string;
  name: string;
  logo: string;
  url: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  referrerDomain: string;
}

const bookmakers: Bookmaker[] = [
  {
    id: '32win',
    name: '32win',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/32win.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin01-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: '789f',
    name: '789f',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/789f.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin02-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: '98win',
    name: '98win',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/98win.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin03-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: 'kuwin',
    name: 'kuwin',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/kuwin.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin04-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: 'okfun',
    name: 'okfun',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/okfun.webp',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin05-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: 'tg88',
    name: 'tg88',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/tg88.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin06-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: 'uu88',
    name: 'uu88',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/uu88.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin07-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: '32win',
    name: '32win',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/32win.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin08-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: '789f',
    name: '789f',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/789f.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin09-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  },
  {
    id: '98win',
    name: '98win',
    logo: 'https://10592a1a07e.vws.vegacdn.vn/xoilaccx/nhacai/98win.png',
    url: 'https://okwintv01.okfun.vin/register.html',
    utmSource: 'okwintv',
    utmMedium: 'logo-topnhacaiuytin10-150x150',
    utmCampaign: 'cpd',
    utmTerm: 'live',
    referrerDomain: 'okwintv.top'
  }
];

const TopBookmakers: React.FC = () => {
  const swiperRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = React.useState(true);
  const [isTransitioning, setIsTransitioning] = React.useState(false);

  const itemsPerView = 5; // Số item hiển thị cùng lúc
  const totalItems = bookmakers.length;

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev + 1) % totalItems);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev - 1 + totalItems) % totalItems);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  // Auto play với pause khi hover
  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      nextSlide();
    }, 2500); // Giảm thời gian để chạy nhanh hơn

    return () => clearInterval(interval);
  }, [isAutoPlaying, isTransitioning]);

  const buildUrl = (bookmaker: Bookmaker) => {
    const params = new URLSearchParams({
      utm_source: bookmaker.utmSource,
      utm_medium: bookmaker.utmMedium,
      utm_campaign: bookmaker.utmCampaign,
      utm_term: bookmaker.utmTerm,
      referrer_domain: bookmaker.referrerDomain
    });
    
    return `${bookmaker.url}&${params.toString()}`;
  };

  return (
    <div className="style2 pt-0 styles_box__Zt84h">
      <div className="styles_container__e4_Wo">
        <div className="styles_top__fNxyM">
          <span className="d-flex items-center uppercase">Cập nhật top nhà cái uy tín OKWIN</span>
          <div className="styles_divider__ablqt"></div>
          <Link className="styles_viewAll__3jMkb" href="/top-nha-cai-uy-tin">
            Tất cả
          </Link>
        </div>
        
        <div className="styles_prev__Nc1M9" onClick={prevSlide}>
          <FontAwesomeIcon icon={faChevronLeft} className="text-white text-lg" />
        </div>
        
        <div 
          className="swiper swiper-initialized swiper-horizontal swiper-pointer-events styles_swiper__YqgGA"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          <div 
            className="swiper-wrapper" 
            ref={swiperRef}
            style={{
              transform: `translate3d(-${currentIndex * 133.158}px, 0px, 0px)`,
              transition: isTransitioning ? 'transform 0.5s ease-in-out' : 'none'
            }}
          >
            {/* Duplicate items for infinite loop */}
            {[...bookmakers, ...bookmakers, ...bookmakers].map((bookmaker, index) => (
              <div 
                key={`${bookmaker.id}-${index}`}
                className={`swiper-slide styles_eachItem__jr04D ${
                  index === currentIndex + totalItems ? 'swiper-slide-active' : ''
                }`}
                style={{
                  width: '128.158px',
                  marginRight: '5px'
                }}
              >
                <div className="styles_group__OLpX2">
                  <Link 
                    target="_blank" 
                    rel="nofollow" 
                    href={buildUrl(bookmaker)}
                  >
                    <img 
                      alt={bookmaker.name} 
                      src={bookmaker.logo} 
                      width={80} 
                      height={80} 
                      className="styles_img__0iBMW"
                      loading="lazy"
                    />
                  </Link>
                  
                  <div className="styles_button__rkchz">
                    <Link 
                      target="_blank" 
                      className="styles_btnBet__XXiZ1" 
                      rel="nofollow" 
                      href={buildUrl(bookmaker)}
                    >
                      Đặt cược
                    </Link>
                    <Link 
                      target="_blank" 
                      className="styles_btnEndow__Z5ckW" 
                      rel="nofollow" 
                      href={`/review-nha-cai-${bookmaker.id}`}
                    >
                      Đánh giá
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="styles_next__YHq8z" onClick={nextSlide}>
          <FontAwesomeIcon icon={faChevronRight} className="text-white text-lg" />
        </div>
      </div>
    </div>
  );
};

export default TopBookmakers;
